<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		:style="getWrapperStyle(node)"
		@click="onNodeClick(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<div
			:class="getClass(node)"
			:style="style"
			:contenteditable="false"
		>
			<!-- @focusout="onInput" -->
			<!-- <p v-html="node.options && node.options.content"></p> -->
			<NodeEditor
				:key="node.key"
				v-model="node.options.content"
				@focus="onNodeClick(node)"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
// eslint-disable-next-line
import NodeEditor from '@/components/funnels/pagebuilder/nodes/NodeEditor.vue';
import {
	getNodeStyle,
	duplicateVar,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeParagraph',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		// eslint-disable-next-line
		NodeEditor,
	},
	data() {
		return {
			isCanEdit: false,
			editor: null,
		};
	},
	// mounted() {
	// 	window.addEventListener(`historyEvent-${this.node.key}`, this.historyEvent);
	// },
	// beforeDestroy() {
	// 	window.removeEventListener(`historyEvent-${this.node.key}`, this.historyEvent);
	// },
	methods: {
		...mapActions({
			setActionElement: 'funnels/setActionElement',
		}),
		getClass(node) {
			let pClass = node.class || '';
			if (node.options && node.options.align) {
				pClass += ` text-${node.options.align}`;
			}

			return pClass;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'line-height',
				// 'padding',
				'border',
				'bg-color',
				'bg-img',
				'box-shadow',
				'text-shadow',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
				'padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
			// this.setActionElement({ type, node });
		},
		onInput(e) {
			const text = e.target.innerText;
			this.node.options.content = text;
		},
		historyEvent(event) {
			const detail = event.detail;
			const nodeKey = duplicateVar(this.node.key);
			if (nodeKey === detail.nodeKey) {
				this.node.options[detail.key] = detail.value;
			}
		},
	},
	computed: {
		style() {
			return this.getStyle(this.node);
		},
	},
};
</script>

<style scoped></style>
